var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-page"},[_c('iframe',{staticClass:"terms-frame",attrs:{"src":_vm.termsUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }